import { render, staticRenderFns } from "./TabInventoryContacts.vue?vue&type=template&id=3570bfbe"
import script from "./TabInventoryContacts.vue?vue&type=script&lang=ts"
export * from "./TabInventoryContacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports